
import { RevButtonBase } from '@ds/components/ButtonBase'
import { RevCardCarousel } from '@ds/components/CardCarousel'
import { RevIllustration } from '@ds/components/Illustration'
import { RevModal } from '@ds/components/Modal'
import { openModal } from '@ds/components/ModalBase'
import { RevSkeleton } from '@ds/components/Skeleton'
import isEmpty from 'lodash/isEmpty'

import LoadInViewport from '@core/components/LoadInViewport'
import {
  trackClick,
  trackHoverOver,
  trackVideosBlockImpression,
} from '@tracking/events'

import BlockTitle from '../private/BlockTitle'
import VideoRender from '../private/VideoRender'

import { HOVER_OVER_VIDEO_DURATION } from './Videos.constants'

export default {
  components: {
    BlockTitle,
    LoadInViewport,
    RevButtonBase,
    RevCardCarousel,
    RevIllustration,
    RevModal,
    RevSkeleton,
    VideoRender,
  },
  props: {
    subtitle: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    tracking: {
      type: Object,
      default: () => ({}),
    },
    videos: {
      type: Array,
      required: true,
    },
    blockPosition: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      isPlaying: false,
      showThumbnail: this.videos.reduce(
        (acc, { id }) => ({ ...acc, [id]: true }),
        {},
      ),
    }
  },
  computed: {
    filteredVideos() {
      return this.videos.filter(({ video }) => !isEmpty(video))
    },
    placeholderHeight() {
      const videoWithImage = this.videos.find(({ image = {} }) => image.height)
      const height = videoWithImage?.image.height || 455

      return `${height}px`
    },
  },
  mounted() {
    this.focusTimeout = null
  },
  destroyed() {
    if (this.focusTimeout) {
      clearTimeout(this.focusTimeout)
    }
  },
  methods: {
    trackBlock() {
      trackVideosBlockImpression({
        ...this.tracking,
        blockPosition: this.blockPosition,
      })
    },
    play({ id, video, index }) {
      if (!this.isPlaying) {
        this.showThumbnail[id] = false
        this.$refs[id][0].$el.play()
        this.isPlaying = true
        this.focusTimeout = setTimeout(() => {
          trackHoverOver({
            ...this.tracking,
            position: index,
            name: video.title,
          })
        }, HOVER_OVER_VIDEO_DURATION)
      }
    },
    pause(id) {
      if (this.isPlaying && this.focusTimeout) {
        this.$refs[id][0].$el.pause()
        this.isPlaying = false
        clearTimeout(this.focusTimeout)
      }
    },
    handleVideoClick({ video, index }) {
      openModal(video.title)
      trackClick({
        ...this.tracking,
        position: index,
        name: video.title,
      })
    },
  },
}
